import { render, staticRenderFns } from "./MemberNotification.vue?vue&type=template&id=2b838ade&scoped=true&"
import script from "./MemberNotification.vue?vue&type=script&lang=js&"
export * from "./MemberNotification.vue?vue&type=script&lang=js&"
import style0 from "./MemberNotification.vue?vue&type=style&index=0&id=2b838ade&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b838ade",
  null
  
)

export default component.exports